import { useEffect, useState, useCallback } from "react";
import ListaAnketa from "./AnketaListKorisnik";
import anketaService from "../../services/anketa.service";
import SearchBar from "../../components/SearchBar";
import { Row, Col, Button, Space, Dropdown, Menu, Input, Modal } from "antd";
import {
  DownOutlined,
  UpOutlined,
  TableOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import Background from "../../components/Background4";
import "../Dokument/DokumentsPageKorisnik.css";
import AnketaCardsKorisnik from "./AnketaCardKorisnik";

const AnketaKorisnik = () => {
  const [ankete, setAnkete] = useState([]);
  const [searchTitle, setSearchTitle] = useState("");
  const [pristupniToken, setPristupniToken] = useState("");
  const navigate = useNavigate();
  const [sortCriteria, setSortCriteria] = useState("datumKreiranja");
  const [sortOrder, setSortOrder] = useState("asc");
  const [isListView, setListView] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);

  const handleModalOk = () => {
    setModalVisible(false);
  };

  const fetchAnkete = useCallback(async () => {
    try {
      const result = await anketaService.getByStatusAndTip("AKTIVNA", "JAVNA");
      const trenutnoVreme = new Date();

      const filtriraneAnkete = result.data.filter((anketa) => {
        if (!anketa.datumVazenja) return true;

        const datumVazenja = new Date(anketa.datumVazenja);
        return !isNaN(datumVazenja) && datumVazenja > trenutnoVreme;
      });

      setAnkete(filtriraneAnkete);
    } catch (error) {}
  }, []);

  const sortAnkete = (ankete) => {
    return ankete.sort((a, b) => {
      let comparison = 0;
      if (sortCriteria === "datumKreiranja") {
        comparison = new Date(a.datumKreiranja) - new Date(b.datumKreiranja);
      } else if (sortCriteria === "naziv") {
        comparison = a.naziv.localeCompare(b.naziv);
      } else if (sortCriteria === "datumVazenja") {
        comparison = new Date(a.datumVazenja) - new Date(b.datumVazenja);
      }
      return sortOrder === "asc" ? comparison : -comparison;
    });
  };

  useEffect(() => {
    fetchAnkete();
  }, [fetchAnkete]);

  const handleInputToken = async () => {
    if (!pristupniToken.trim()) {
      setModalVisible(true);
      return;
    }

    try {
      const response = await anketaService.getIdByToken(pristupniToken);
      const id = response.data;
      navigate(`/ankete/${id}`);
    } catch (error) {
      setModalVisible(true);
    }
  };
  const filtriraneAnkete = ankete.filter((anketa) =>
    anketa.naziv.toLowerCase().includes(searchTitle.trim().toLowerCase())
  );

  const sortedAnkete = sortAnkete([...filtriraneAnkete]);
  const sortMenu = (
    <Menu onClick={(e) => setSortCriteria(e.key)}>
      <Menu.Item key="datumKreiranja">Datum objave</Menu.Item>
      <Menu.Item key="datumVazenja">Datum važenja</Menu.Item>
      <Menu.Item key="naziv">Naziv</Menu.Item>{" "}
    </Menu>
  );

  return (
    <div>
      <Background />
      <div className="docs-border">
        <div className="docs-container">
          <Row align="middle" style={{ width: "90%" }}>
            <Col
              className="document-view-right"
              style={{ marginTop: "0px", marginBottom: "30px" }}
            >
              <Space>
                <Input
                  className="input-field add-new-pitanje-input"
                  value={pristupniToken}
                  onChange={(e) => setPristupniToken(e.target.value)}
                  placeholder="Pristupni token"
                />
                <Button
                  onClick={handleInputToken}
                  className="button-primary"
                  style={{ height: "35px" }}
                >
                  Pristupi
                </Button>
              </Space>
            </Col>
          </Row>
          <Row justify="center" align="middle" style={{ width: "90%" }}>
            <Col span={24}>
              <div className="page-title-and-search">
                <h1 className="page-title">Ankete</h1>
                <SearchBar
                  searchTitle={searchTitle}
                  setSearchTitle={setSearchTitle}
                />
              </div>
            </Col>
          </Row>
          <Row align="middle" style={{ width: "90%" }}>
            <Col className="document-view-right">
              <Space>
                <Button
                  icon={isListView ? <TableOutlined /> : <MenuOutlined />}
                  onClick={() => setListView(!isListView)}
                />
                <Button
                  onClick={() =>
                    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"))
                  }
                >
                  {sortOrder === "asc" ? <UpOutlined /> : <DownOutlined />}
                </Button>
                <Dropdown overlay={sortMenu} trigger={["click"]}>
                  <Button>
                    Sortiraj
                    <DownOutlined />
                  </Button>
                </Dropdown>
              </Space>
            </Col>
          </Row>
          <div className="dokument-list-div">
            {isListView ? (
              <ListaAnketa ankete={sortedAnkete} />
            ) : (
              <AnketaCardsKorisnik ankete={sortedAnkete} />
            )}
          </div>
        </div>
      </div>
      <Modal
        title="Greška"
        open={modalVisible}
        onCancel={handleModalOk}
        footer={[
          <Button key="back" type="primary" onClick={handleModalOk}>
            Povratak
          </Button>,
        ]}
        className="saglasnost-modal"
      >
        <p>Neispravan unos! Ne postoji anketa sa datim tokenom.</p>
      </Modal>
    </div>
  );
};

export default AnketaKorisnik;
